import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modelType === 2 && _ctx.theModel?.Positive !== undefined && !_ctx.isParameter)
      ? (_openBlock(), _createBlock(_component_q_toggle, {
          key: 0,
          modelValue: _ctx.theModel.Positive,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel.Positive) = $event)),
          class: _normalizeClass(["q-mr-none q-pr-none", `q-pa-none toggle-checkbox q-mr-none ${_ctx.modelType === 2 ?'unset-items-center' : 'items-center'}`]),
          "checked-icon": "add",
          style: _normalizeStyle(_ctx.shiftTop ? 'margin-top: -2;' : 'margin-top: 0;'),
          color: "navy",
          label: " ",
          size: "xs",
          "unchecked-icon": "remove"
        }, null, 8, ["modelValue", "style", "class"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle((_ctx.shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;'))
    }, [
      _createVNode(_component_VueDatePicker, {
        utc: "preserve",
        timezone: "Europe/Moscow",
        locale: _ctx.$i18n.locale,
        style: _normalizeStyle('width: '+_ctx.fieldWidth+'px; min-width: '+_ctx.fieldWidth+'px; max-width: '+_ctx.fieldWidth+'px;'),
        teleport: true,
        modelValue: (this.theModel as SelectionDateStampsFilterSend).StartDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((this.theModel as SelectionDateStampsFilterSend).StartDate) = $event)),
        "enable-time-picker": _ctx.showTime,
        clearable: false,
        required: true,
        format: _ctx.showTime ? _ctx.formatTime : _ctx.formatDate,
        "text-input": _ctx.textInputOptions
      }, null, 8, ["locale", "style", "modelValue", "enable-time-picker", "format", "text-input"])
    ], 4),
    _createElementVNode("div", {
      class: _normalizeClass(['cursor-pointer', 'text-grey-8' ]),
      style: _normalizeStyle((_ctx.shiftTop ? 'margin-top: -4px;' : 'margin-top: 3px;'))
    }, "  -  ", 4),
    _createElementVNode("div", {
      style: _normalizeStyle((_ctx.shiftTop ? 'margin-top: -2px;' : 'margin-top: 2px;'))
    }, [
      _createVNode(_component_VueDatePicker, {
        utc: "preserve",
        timezone: "Europe/Moscow",
        locale: _ctx.$i18n.locale,
        style: _normalizeStyle('width: '+_ctx.fieldWidth+'px; min-width: '+_ctx.fieldWidth+'px; max-width: '+_ctx.fieldWidth+'px;'),
        modelValue: (this.theModel as SelectionDateStampsFilterSend).EndDate,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (((this.theModel as SelectionDateStampsFilterSend).EndDate) = $event)),
        teleport: true,
        clearable: false,
        disabled: _ctx.theModel && (_ctx.theModel as SelectionDateStampsFilterSend).EndDateIsToday,
        format: _ctx.showTime ? _ctx.formatTime : _ctx.formatDate,
        "text-input": _ctx.textInputOptions,
        "enable-time-picker": _ctx.showTime
      }, null, 8, ["locale", "style", "modelValue", "disabled", "format", "text-input", "enable-time-picker"])
    ], 4),
    _createVNode(_component_mosta_checkbox, {
      class: "q-my-none q-py-none text-grey-8",
      "onUpdate:modelValue": [
        _ctx.updateCheck,
        _cache[3] || (_cache[3] = ($event: any) => (((_ctx.theModel as SelectionDateStampsFilterSend).EndDateIsToday) = $event))
      ],
      style: 'margin-left: 6px; margin-top: 4px;',
      modelValue: (_ctx.theModel as SelectionDateStampsFilterSend).EndDateIsToday,
      label: _ctx.$t('today_calendar')
    }, null, 8, ["onUpdate:modelValue", "modelValue", "label"]),
    (_ctx.modelType === 2 && _ctx.theModel?.Positive !== undefined && !_ctx.isParameter)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 1,
          class: "q-px-none q-mx-none unset-items-center",
          style: {"margin-left":"2px"},
          flat: "",
          dense: "",
          "aria-label": _ctx.$t('delete_filter'),
          icon: "close",
          size: "sm",
          tabindex: "-1",
          color: "grey-8",
          onClick: _ctx.emitDelete
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, { delay: 1000 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["aria-label", "onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}